/**
 * Reading mode utility using localStorage.
 * Modes: 'default', 'sepia', 'dark'
 */

const STORAGE_KEY = "ofalycee_reading_mode";
const FONT_SIZE_KEY = "ofalycee_font_size";
const FONT_FAMILY_KEY = "ofalycee_font_family";

export const FONT_FAMILIES = {
  default: { label: "Poppins", value: "'Poppins', sans-serif" },
  georgia: { label: "Georgia", value: "Georgia, 'Times New Roman', serif" },
  times: { label: "Times", value: "'Times New Roman', Times, serif" },
};

export const READING_MODES = {
  default: {
    label: "Clair",
    bg: "bg-white",
    text: "text-gray-900",
    prose: "",
  },
  sepia: {
    label: "Sepia",
    bg: "bg-amber-50",
    text: "text-amber-950",
    prose: "prose-headings:text-amber-900 prose-p:text-amber-950 prose-a:text-amber-700",
  },
  dark: {
    label: "Sombre",
    bg: "bg-gray-900",
    text: "text-gray-100",
    prose: "prose-invert",
  },
};

export function getReadingMode() {
  try {
    return localStorage.getItem(STORAGE_KEY) || "default";
  } catch {
    return "default";
  }
}

export function setReadingMode(mode) {
  localStorage.setItem(STORAGE_KEY, mode);
}

export function getFontSize() {
  try {
    return parseInt(localStorage.getItem(FONT_SIZE_KEY) || "100", 10);
  } catch {
    return 100;
  }
}

export function setFontSize(size) {
  localStorage.setItem(FONT_SIZE_KEY, String(size));
}

export function getFontFamily() {
  try {
    return localStorage.getItem(FONT_FAMILY_KEY) || "default";
  } catch {
    return "default";
  }
}

export function setFontFamily(family) {
  localStorage.setItem(FONT_FAMILY_KEY, family);
}
